import styled from "@emotion/styled";

import { ArticleContentRightSection } from "~/components/article/article-render/article-content/article-content-right-section";

import { OpinionHeader } from "./header";

type OpinionArticleContainerProps = {
  $isColumnistArticle: boolean;
};

export const OpinionArticleContainer = styled.div<OpinionArticleContainerProps>`
  display: grid;
  grid:
    "leading" min-content
    "header" min-content
    "mobile-content-header-ad" min-content
    "content" min-content
    "mobile-content-footer-ad" min-content
    "comment" min-content
    "more-on-this" min-content
    "author-detail" min-content
    "topic" min-content
    "mobile-footer-ad" min-content
    / 100%;

  inline-size: 100%;
  padding-block-end: 42px;

  ${props => props.theme.breakpoints.up("tablet")} {
    grid:
      "header header header" min-content
      "left . leading" min-content
      "left . content" min-content
      "left . tablet-content-footer-ad" min-content
      "left . comment" min-content
      "left . more-on-this" min-content
      "left . author-detail" min-content
      "left . topic" min-content
      "left . ." min-content
      / 44px 20px minmax(0, 1fr);
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    grid:
      "header-ad header-ad header-ad header-ad header-ad" min-content
      "header header header header header" min-content
      "left . leading leading leading" min-content
      "left . content . right" min-content
      "left . comment . right" min-content
      "left . author-detail . right" min-content
      "left . topic . right" min-content
      "left . . . right" min-content
      / 44px 20px minmax(0, 1fr) 40px 300px;
  }

  ${props => props.theme.breakpoints.up("mediumDesktop")} {
    grid:
      "header-ad header-ad header-ad header-ad header-ad header-ad header-ad" min-content
      "header header header header header header header" min-content
      "widgets-bottom . left . leading leading leading" min-content
      "widgets-bottom . left . content . right" min-content
      "widgets-bottom . left . comment . right" min-content
      "widgets-bottom . left . author-detail . right" min-content
      "widgets-bottom . left . topic . right" min-content
      "widgets-bottom . left . . . right" min-content
      / 180px 40px 44px 40px minmax(0, 1fr) 40px 300px;
  }

  > *:empty {
    margin-block-start: 0;
  }
`;

const Widgets = styled.div`
  display: none;

  ${props => props.theme.breakpoints.up("mediumDesktop")} {
    display: flex;
  }
`;

export const WidgetsBottom = styled(Widgets)`
  grid-area: widgets-bottom;

  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-start: 40px;
  }
`;

export const StyledArticleContentRightSection = styled(ArticleContentRightSection)`
  ${props => props.theme.breakpoints.up("desktop")} {
    margin-block-start: 40px;
  }
`;

export const StyledOpinionHeader = styled(OpinionHeader)`
  grid-area: header;
`;
